import { useAppSelector } from "@litres-core/store";
import { useHasWindow, useLocation } from "@litres-libs/global-hooks";
import {
  isSchoolDomain as isSchoolDomainFunction,
  isBiblioDomain as isLibraryDomainFunction,
  isMobileOperatorDomain as isMobileOperatorDomainFunction,
} from "@litres/utils";
import { SUBSCRIPTION } from "../../constants";
import { MAIN_DOMAIN } from "../../Header";
import { EShowBanner } from "./utils";

export const useMainBanner = (): EShowBanner | null => {
  const { pathname } = useLocation();
  const hasWindow = useHasWindow();

  const faceLanguage = useAppSelector(state => state.face.language || "ru");
  const clientHost = useAppSelector(
    state => state.browser.headers["client-host"] || MAIN_DOMAIN
  );

  const isSchoolDomain = isSchoolDomainFunction(clientHost);
  const isLibraryDomain = isLibraryDomainFunction(clientHost);
  const isMobileOperatorDomain = isMobileOperatorDomainFunction(clientHost);

  const isSubscriptionPage =
    hasWindow &&
    (pathname === SUBSCRIPTION || pathname === "/litres_subscription/");

  if (isSubscriptionPage || isMobileOperatorDomain || isLibraryDomain) {
    // не отображаем баннер для операторских поддоменов, библиотек и лендинга подписки
    return null;
  }

  if (isSchoolDomain) {
    // для школьного поддомена отображаем хардкодный баннер
    return EShowBanner.SCHOOL;
  }

  if (faceLanguage === "ru" || faceLanguage === "az" || faceLanguage === "uz") {
    // баннер отображаем только для az/uz/ru доменов
    // логика по отображению баннера находится в рекламных сервисах, кроме школьных поддоменов
    return EShowBanner.MAIN_PROMO;
  }

  return null;
};
